type AddFn = (type: 'success' | 'error' | 'info', message: string, persistent?: boolean) => string;
type RemoveFn = (id: string) => void;

let _add: AddFn | undefined;
let _remove: RemoveFn | undefined;

export function registerGlobalToast(add: AddFn, remove: RemoveFn): void {
  _add = add;
  _remove = remove;
}

export const globalToast = {
  show(message: string): string | undefined {
    return _add?.('info', message, true);
  },
  dismiss(id: string | undefined): void {
    if (id) _remove?.(id);
  },
};
